import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=133a097d&"
import script from "./ShareView.vue?vue&type=script&lang=js&"
export * from "./ShareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports